import React, { HTMLAttributes, HTMLProps } from 'react';
import Immutable from 'immutable';

import { ImmutableGenericNodeEntity } from '../..';
import { CoreLink } from '../../../../components';
import { DEFAULT_LANGUAGE } from '../../../../config/constants';
import useClasses from '../../../../hooks/useClasses';

import './style.scss';

interface Props extends HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableGenericNodeEntity;
}

const NodeTipTeaser: React.FC<Props> = ({ entity, className }) => {
  const { buildClass, joinClasses } = useClasses('NodeTipTeaser');

  const langcode = entity.getIn(['langcode', 0, 'value'], DEFAULT_LANGUAGE);
  const path = entity.getIn(['paths', langcode], '');
  const title = entity.getIn(['title', 0, 'value'], '');
  const isUpvoted = (entity.getIn(['flags', 'upvote_tip'], Immutable.List()) as Immutable.List<unknown>).size > 0;

  return (
    <li className={joinClasses(buildClass(), className)}>
      <CoreLink to={path} className={buildClass('link', isUpvoted ? 'upvoted' : '')} title={title} />
    </li>
  );
};

export default NodeTipTeaser;
